/**
 * The password rule, mirrored from the backend (utils/password-policy.util.ts) for
 * instant feedback — the server re-checks. 72 BYTES, not characters: bcrypt ignores
 * anything past that, so a longer password would silently be a shorter one.
 */
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX_BYTES = 72;

export function passwordProblem(pw: string): string | null {
  if (pw.length < PASSWORD_MIN) return `Use at least ${PASSWORD_MIN} characters`;
  if (new TextEncoder().encode(pw).length > PASSWORD_MAX_BYTES)
    return 'Too long — keep it under 72 characters';
  return null;
}
